import { api } from "../base";
import type {
  IAssetRefPrice,
  IAssetRefPricesRequest,
  IAssetRefPricesResponse,
} from "@pulse-ui/codegen-v2/generated_ts/asset_ref_price";

export type { IAssetRefPrice, IAssetRefPricesRequest, IAssetRefPricesResponse };

// The wire omits usd_mid/excluded_reason when absent, so they arrive as
// `undefined` despite the generated type saying `| null` — always use `== null`.
export function isPriced(
  entry: IAssetRefPrice | undefined,
): entry is IAssetRefPrice & { usd_mid: string } {
  return entry != null && entry.usd_mid != null && entry.excluded_reason == null;
}

// Asset codes are always compared/keyed by their normalized upper-cased form.
export function normalizeAssetCode(code: string): string {
  return code.trim().toUpperCase();
}

const assetRefPricesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Batch USD-mid lookup off the BBO/mark-price cache. A mutation, not a
     * query: every fetch is an explicit act and must never be cache-served.
     */
    getAssetRefPrices: build.mutation<
      IAssetRefPricesResponse,
      IAssetRefPricesRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/asset-ref-prices",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetAssetRefPricesMutation } = assetRefPricesEndpoints;
